import useSafeState from "../utils/safe-state";
import {
    Button,
    Checkbox,
    CheckboxProps,
    Col,
    Form,
    Input,
    InputNumber,
    message,
    Row,
    Select,
    Spin,
    Tooltip
} from "antd";
import React, {useEffect, useState} from "react";
import {Trans} from "@lingui/macro";
import {useAxios} from "../utils/hooks";
import {openNotification} from "../utils/openNotification";

interface Interface{
    data?: any;
    mode?: 'Edit' | 'Add new';
    onClose?: () => void;
}

const SupplierDrawer = (props: Interface) => {

    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");
    const config = {headers: {'Content-Type': 'application/json'}};
    const data = props.data || {};
    const [form] = Form.useForm();
    const [loading, setLoading] = useSafeState(false);
    const [isEu, setIsEu] = useState(false);

    const handleEdit = () => {
        if (axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current
                .put(
                    ('/resource/suppliers/id?id='
                        + encodeURIComponent(form.getFieldValue(['code']))
                    ),
                    {
                        code: form.getFieldValue(['code']),
                        name: form.getFieldValue(['name']),
                        isEu: isEu,
                        version: form.getFieldValue(['version'])
                    },
                    config,
                )
                .then(() => {
                    openNotification('success', '');
                    props.onClose && props.onClose();
                })
                .catch(function (error: any) {
                    openNotification('error', error, props);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    useEffect(() => {

        form.resetFields();

        if(props.mode === 'Edit') {

            let fieldsValues = [];
            for (const [key, value] of Object.entries(data)) {
                fieldsValues.push({name: key, value: value});
                console.log(key, value);
                if(key === 'isEu'){
                    setIsEu(value == true);
                }
            }
            form.setFields(fieldsValues);
        }

    }, []);

    const handleFinish = () => {

        if (axiosInstance.current != null) {
            setLoading(true);
            axiosInstance.current
                .post(
                    ('/resource/suppliers'),
                    {
                        code: form.getFieldValue(['code']),
                        name: form.getFieldValue(['name']),
                        isEu: isEu,
                        version: form.getFieldValue(['version'])
                    },
                    config,
                )
                .then(() => {
                    openNotification('success', '');
                    props.onClose && props.onClose();
                })
                .catch(function (error: any) {
                    openNotification('error', error, props);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }

    const onReset = () => {
        form.resetFields();
        setIsEu(false)
    };

    const onChangeIsEu: CheckboxProps['onChange'] = (e) => {
        setIsEu(e.target.checked);
    };


    return (
        <Form
            id="newSupplier"
            layout='vertical'
            form={form}
            onFinish={() => (props.mode === 'Edit' ? handleEdit() : handleFinish())}
        >
            <>
                <Spin spinning={loading}></Spin>
                <Row gutter={24}>
                    <Col span={4}>
                        <Form.Item
                            name="code"
                            label={<Trans>Code</Trans>}
                            children={<Input disabled={props.mode === 'Edit' ? true : false}/>}
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please enter the code</Trans>
                            }]}
                        />
                    </Col>
                    <Col span={20}>
                        <Form.Item
                            name="name"
                            label={<Trans>Name</Trans>}
                            children={<Input/>}
                            rules={[{
                                type: "string",
                                required: true,
                                message: <Trans>Please enter the name</Trans>
                            }]}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <Form.Item
                            name="isEu"
                            children={
                                <Checkbox onChange={onChangeIsEu} checked={isEu}><Trans>EU member</Trans></Checkbox>
                            }
                        />
                    </Col>
                </Row>
            </>

            {props.mode === 'Edit'
                ? (<Button htmlType="button" type="primary" onClick={() => form.submit()}>
                    <Trans>Save</Trans>
                </Button>)
                :
                <>
                    <Button htmlType="button" style={{ marginRight: 8 }} onClick={() => onReset()}>
                        <Trans>Clear</Trans>
                    </Button>
                    <Button
                        loading={loading}
                        htmlType="button"
                        type="primary"
                        style={{ marginRight: 8 }}
                        onClick={() => form.submit()}
                    >
                        <Trans>Save</Trans>
                    </Button>
                </>
            }
        </Form>
    );

}
export default SupplierDrawer;
